export default __webpack_public_path__ + "static/media/edit.3cfde3dd.svg";